import React from 'react';
import { Link } from '@reach/router';
import { NavLink as RSNavLink } from 'reactstrap';
import { cx, PropTypes, Icon } from '~/utils';

export { Router, navigate, Redirect } from '@reach/router';

export function NavLink( props_in ) {
  // eslint-disable-next-line prefer-const
  let { icon, label, className, children, ...props } = props_in;
  if ( label && ! children ) children = <Icon icon={icon} label={label} />;
  props.className = cx( 'navlink', className );
  return <RSNavLink tag={Link} {...props}>{children}</RSNavLink>;
}
NavLink.propTypes = {
  to              : PropTypes.string,     // @reach/router
  disabled        : PropTypes.bool,       // reactstrap
  active          : PropTypes.bool,       // reactstrap
  innerRef        : PropTypes.func,       // reactstrap
  tag             : PropTypes.node,       // reactstrap
  icon            : PropTypes.string,
  label           : PropTypes.string,
  children        : PropTypes.node,
  className       : PropTypes.className,
};

export { Link };
